// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createAccountStyles } from "@awc/Overrides/Widgets/CreateAccount/CreateAccount";
import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { xScreen } from "@awc/XDL/Utilities";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { css } from "styled-components";

const newCustomerStyle: TextFieldPresentationProps = {
    labelProps: {
        css: css`
            min-width: 40%;
            text-align: left;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            flex-grow: 1;
        `,
    },
};

createAccountStyles.requiredGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        row-gap: 12px;
    `,
};

createAccountStyles.requiredText = {
    forwardAs: "p",
};

createAccountStyles.sharedGridItem = {
    width: [12, 12, 6, 6, 6],
};

createAccountStyles.accountNoGridItem = {
    width: 12,
};
createAccountStyles.mainGridContainer = {
    gap: 12,
};

createAccountStyles.userNameGridItem = {
    width: 12,
};

createAccountStyles.emailGridItem = {
    width: 12,
};

createAccountStyles.phoneGridItem = {
    width: 12,
};

createAccountStyles.passwordGridItem = {
    width: 12,
};

createAccountStyles.confirmPasswordGridItem = {
    width: 12,
};

createAccountStyles.existingCustomerGridItem = {
    width: 12,
};

createAccountStyles.userGridContainer = {
    gap: 12,
    css: css`
        max-width: unset;
    `,
};

createAccountStyles.userGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css``,
};
createAccountStyles.applyAsExistingCustomerWrapper = {
    css: css`
        display: flex;
        column-gap: 20px;
        align-items: baseline;
    `,
};
createAccountStyles.requirementsGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};
createAccountStyles.activationInstructionGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        padding-left: 50px;
        ${xScreen("lte", "md")} {
            padding-left: 6px;
        }
    `,
};
createAccountStyles.reCaptchaGridItem = { width: 12 };

createAccountStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};
createAccountStyles.accountNoTextField = {
    ...newCustomerStyle,
};
createAccountStyles.passwordTextField = {
    ...newCustomerStyle,
};
createAccountStyles.confirmPasswordTextField = {
    ...newCustomerStyle,
};
createAccountStyles.userNameTextField = {
    ...newCustomerStyle,
};
createAccountStyles.emailTextField = {
    ...newCustomerStyle,
};
createAccountStyles.phoneTextField = {
    ...newCustomerStyle,
};
createAccountStyles.billingTitle = {
    css: css`
        margin: 0;
    `,
};
createAccountStyles.requirementsWrapper = {
    css: css`
        ${styledBoxStyle}
        margin-left: 24px;
        ${xScreen("lte", "md")} {
            margin-left: 0;
        }
    `,
};
